import SmoothScrollbars from "@rio-cloud/rio-uikit/components/smoothScrollbars/SmoothScrollbars";
import Tree from '@rio-cloud/rio-uikit/Tree';
import { IVehicle } from "src/screens/tripsListRoute";
// import './tree.css'
import { useState } from "react";

export type Groups = {
    id: string,
    name: string,
}

interface ISidebarVehiclesProps {
    groups?: Groups[];
    allVehicles?: IVehicle[];
    handleSelected: (groups: string[], items: string[]) => void;
    groupsSelected: string[];
    itemsSelected: string[];
}

const SidebarVehicles = ({ groups, allVehicles, handleSelected, groupsSelected, itemsSelected }: ISidebarVehiclesProps) => {
   
    return (
        <SmoothScrollbars>
            <Tree            
                searchPlaceholder="Buscar veículo"
                showEmptyGroups={true}
                items={allVehicles && allVehicles.length > 0 ? allVehicles?.map((vehicle) => {
                    return {
                        id: vehicle.id as string,
                        name: vehicle.name as string,
                        className: 'display-flex align-items-center',
                        type: vehicle.type as string,
                        groupIds: vehicle.groupIds && vehicle.groupIds?.length > 0 ? vehicle.groupIds as string[] : ['00000000-0000-0000-0000-000000000000'],
                    }
                }) : undefined}
                onSelectionChange={({ groups, items }) => {
                     let selectedItems = items;

                    if (groups.length > 0 && items.length === 0) {
                        selectedItems =
                            allVehicles
                                ?.filter((vehicle) =>
                                    vehicle.groupIds?.some((groupId) =>
                                        groups.includes(groupId)
                                    )
                                )
                                .map((vehicle) => vehicle.id as string) ?? [];
                    }

                    handleSelected(groups, selectedItems);
                }}
                groups={groups}
                expandedGroups={groups ? [...groups.map((res) => res.id), 'none'] : ['none']}
                selectedGroups={groupsSelected}
                selectedItems={itemsSelected}
                hasMultiselect
            />
        </SmoothScrollbars>
    )
}

export default SidebarVehicles;